import './PercentileIndicator.scss';

export enum PercentileScope {
  NATIONWIDE = 'nationwide',
  STATEWIDE = 'statewide',
}

interface PercentileIndicatorProps {
  percentile: number;
  scope?: PercentileScope;
  showLabel?: boolean;
}

function getColorClass(percentile: number): string {
  if (percentile >= 50) return 'percentile-indicator--green';
  if (percentile >= 25) return 'percentile-indicator--yellow';
  return 'percentile-indicator--orange';
}

export function PercentileIndicator({ percentile, scope = PercentileScope.NATIONWIDE, showLabel = true }: PercentileIndicatorProps) {
  const colorClass = getColorClass(percentile);
  const clampedPercentile = Math.max(0, Math.min(100, percentile));
  const scopeText = scope === PercentileScope.NATIONWIDE ? 'nationwide' : 'in their state';
  const tooltipContent = `This institution is larger than ${Math.round(clampedPercentile)}% of institutions ${scopeText}`;

  return (
    <div
      className={`percentile-indicator ${colorClass}`}
      data-tooltip-id="main-tooltip"
      data-tooltip-content={tooltipContent}
      data-tooltip-delay-show={0}
    >
      <div className="percentile-indicator__bar">
        <div
          className="percentile-indicator__fill"
          style={{ width: `${clampedPercentile}%` }}
        />
      </div>
      {showLabel && <span className="percentile-indicator__label">P{Math.round(clampedPercentile)}</span>}
    </div>
  );
}
